// extracted by mini-css-extract-plugin
export default {"form":"Checkout_form__g1sh-","inputs":"Checkout_inputs__Qp1Wj","wrapper":"Checkout_wrapper__swIgm","form-wrapper":"Checkout_form-wrapper__vJH3t"};